import { createSlice } from "@reduxjs/toolkit";
import { PhotoAlbumThunk } from "../Thunk/PhotoAlbumThunk";

let initState = {
	reload: true,
	sliders: [],
	error: null,
};

const PhotoAlbumReducer = createSlice({
	name: "PhotoAlbumReducer",

	initialState: initState,
	reducers: {},
	extraReducers: (builder) => {
		builder

			.addCase(PhotoAlbumThunk.pending, (state, action) => {
				state.reload = true;
			})
			.addCase(PhotoAlbumThunk.fulfilled, (state, action) => {
				state.reload = false;
				state.sliders = action.payload.data;
			});
	},
});
export default PhotoAlbumReducer.reducer;
